import React from 'react';
import { Col } from 'react-bootstrap';

const FormField = ({ title, handleForm, options, value }) => {
      return (
            <>
                  <Col lg={12}>
                        <fieldset>
                              <legend>{title}</legend>
                              <div class="radio-group">
                                    {options?.map((item, index) => (
                                          <label key={index}>
                                                <input
                                                      type="radio"
                                                      value={item?.value}
                                                      checked={
                                                            item?.value ===
                                                            value
                                                      }
                                                      onClick={(event) =>
                                                            handleForm(
                                                                  event.target
                                                                        .value
                                                            )
                                                      }
                                                />
                                                <span>{item?.title}</span>
                                          </label>
                                    ))}
                              </div>
                        </fieldset>
                  </Col>
            </>
      );
};

export default FormField;
